<template>
    <div class="w-full my-6">
        <!-- Header -->
        <div class="flex items-center justify-between mb-6">
            <div>
                <h2 class="text-2xl font-bold text-white">Latest Episodes</h2>
                <p class="text-nomad-300 text-sm mt-1">Popular Somali podcasts</p>
            </div>
            <Link href="/podcasts"
                class="text-nomad-accent hover:text-nomad-accent/80 text-sm font-medium transition-colors">
            View All →
            </Link>
        </div>

        <!-- Episodes Grid -->
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            <div v-for="episode in podcasts" :key="episode.id"
                class="bg-nomad-800 rounded-lg overflow-hidden hover:shadow-lg transition-all duration-300">
                <!-- Episode Content -->
                <div class="p-4 flex gap-4">
                    <!-- Play Button -->
                    <button @click="prepareCurrent({ id: episode.id, type: 'EPISODE', title: episode.title || episode.name })" aria-label="Play Episode"
                        class="flex-shrink-0 icon-play rounded-full bg-nomad-accent hover:bg-nomad-accent/80 text-nomad-900 w-12 h-12 flex items-center justify-center transition-all hover:scale-110 font-bold text-lg"></button>

                    <!-- Episode Info -->
                    <div class="flex-1 min-w-0">
                        <p class="text-nomad-400 text-xs font-light mb-1">{{ episode.pubDate }}</p>
                        <h3 class="text-nomad-accent font-semibold text-xs uppercase tracking-wide mb-2">
                            {{ episode.podcast.title }}
                        </h3>
                        <h2 class="text-nomad-200 font-medium text-sm line-clamp-2">
                            <Link :href="'/episode/' + episode.id" class="hover:text-nomad-accent transition-colors">
                            <span v-if="episode.ordering" class="text-nomad-400 text-xs mr-2">#{{ episode.ordering
                                }}</span>{{ episode.title }}
                            </Link>
                        </h2>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import { Link } from "@inertiajs/vue3";
export default {
    props: {
        podcasts: {
            type: Array,
            default: [],
        },
    },
    data() {
        return {};
    },
    methods: {
        ...mapActions("current", ["prepareCurrent"]),
    },
    components: {
        Link,
    },
};
</script>
